import React, { useContext, useState, useEffect, useRef } from "react";
import {
  useResolvedPath,
  useMatch,
  NavLink,
  useLocation,
  matchPath,
} from "react-router-dom";
import { AppSettings } from "./../../config/app-settings.js";
import menus from "./../../config/app-menu.jsx";
import { useDispatch, useSelector } from "react-redux";
import {
  authActions,
  archivedActions,
  myAccountActions,
  masterActions,
  sendPhotosActions,
  writeMessageActions,
} from "../../_store";
import { useNavigate } from "react-router-dom";
import useDraft from "../../components/common/autoSaveDraftMsg/useDraft.jsx";
import translations from "../../config/TranslateFile.jsx";
import { EventLog } from "../../components/common/EventLog/EventLog.jsx";
import { getStoredValue, removeStoredValue, setStoredValue } from "../../_helpers/storagehelper.js";
import useTransactionPending from "../../hooks/useTransactionPending.jsx";


function NavItem({ menu, onClick, ...props }) {
  let resolved = useResolvedPath(menu.path);
  const dispatch = useDispatch();
  let match = useMatch({ path: resolved.pathname });
  const context = useContext(AppSettings);
  const currentLang = translations();
  // const TotalCount = useSelector((state) => state.archived.PULoginUnreadNotificationCountResponse);
  const TotalCount = useSelector(
    (state) => state.archived.PULoginUnreadNotificationCount
  );
  const [menuData, setMenuData] = useState(menus);
  const { setIsSaveTriggered } = useTransactionPending();

  //const [menuItems, setMenuItems] = useState(translations["en"]); // Default translations
  const navigate = useNavigate();
  let location = useLocation();
  const previousPathRef = useRef(""); // Use useRef to persist the previous path

  useEffect(() => {
    // Update the previous path when location changes
    if (location.pathname !== "/public/Messenger") {
      previousPathRef.current = location.pathname;
    }
  }, [location]);

  let match2 =
    (menu.path === "public/Inbox" &&
      (location.pathname.startsWith("/public/Inbox") ||
        (location.pathname.startsWith("/public/Messenger") &&
          previousPathRef.current.startsWith("/public/Inbox")))) ||
    (menu.path === "public/Archived" &&
      (location.pathname.startsWith("/public/Archived") ||
        location.pathname.startsWith("/public/ArchivedMessagesTable") ||
        (location.pathname.startsWith("/public/Messenger") &&
          previousPathRef.current.startsWith("/public/Archived")))) ||
    (menu.path === "public/FindInmates" &&
      (location.pathname.startsWith("/public/FindInmates") ||
        location.pathname.startsWith("/public/FindInmatesTables"))) ||
    (menu.path === "public/PurchaseCredits" &&
      (location.pathname.startsWith("/public/PurchaseCredits") ||
        location.pathname.startsWith("/StripeElementsWrapper"))) ||
    (menu.path === "public/SentPhotos" &&
      (location.pathname.startsWith("/public/SentPhotos") ||
        location.pathname.startsWith("/public/Profile"))) ||
    (menu.path === "public/SentE-Cards" &&
      (location.pathname.startsWith("/public/SentE-Cards") ||
        location.pathname.startsWith("/public/E-CardViewer"))) ||
    (menu.path === "public/WriteMessage" &&
      (location.pathname.startsWith("/public/WriteMessage") ||
        location.pathname.startsWith("/public/SendE-Card"))) ||
    (menu.path === "public/Mycontacts" &&
      (location.pathname.startsWith("/public/Mycontacts") ||
        location.pathname.startsWith("/public/PurchaseHistory")));

  // Browser Back Button Issue Solved
  // const authUser = useSelector((state) => state);
  const { token } = useSelector((state) => state.auth);
  // Function used for If token is not null or undefined means not allow to show login page
  useEffect(() => {
    if (token) {
      window.history.forward();
      //  navigate(from, { replace: true }); // Redirect to the original page or '/dashboard'
    }
  }, [token, navigate]);

  // useEffect(() => {
  //   previousPathRef.current = location.pathname; // Update the ref with the current path
  // }, [location.pathname]);

  const [badgeCounts, setBadgeCounts] = useState({
    Archived: TotalCount[0]?.PUArchieveMsgUnreadCount,
    Inbox: TotalCount[0]?.PUInboxMsgUnreadCount,
    Drafts: TotalCount[0]?.PUDraftMsgUnreadCount,
    EcardHistory: TotalCount[0]?.PUEcardUnreadCount,
  });

  // useEffect(() => {
  //   const publicUserId = getStoredValue("userID");
  //   if (publicUserId) {
  //     dispatch(
  //       archivedActions.PULoginUnreadNotificationCount({ publicUserId })
  //     );
  //   }
  // }, []);


  useEffect(() => {
    if (TotalCount && TotalCount.length > 0) {
      setBadgeCounts({
        Archived: TotalCount[0]?.PUArchieveMsgUnreadCount || 0,
        Inbox: TotalCount[0]?.PUInboxMsgUnreadCount || 0,
        Drafts: TotalCount[0]?.PUDraftMsgUnreadCount || 0,
        EcardHistory: TotalCount[0]?.PUEcardUnreadCount || 0,
      });
    }
  }, [TotalCount]);

  let icon = menu.icon && (
    <div className="menu-icon">
      <i className={menu.icon}></i>
    </div>
  );
  let img = menu.img && (
    <div className="menu-icon-img">
      <img src={menu.img} alt="" />
    </div>
  );
  let caret = menu.children && !menu.badge && (
    <div className="menu-caret"></div>
  );
  let label = menu.label && (
    <span className="menu-label ms-5px">{menu.label}</span>
  );

  //let badge = menu.badge && <div className="menu-badge">{menu.badge}</div>;
  const badge =
    badgeCounts[menu.title] > 0 ? (
      <div className="menu-badge" style={{ backgroundColor: "#FFC506", color: "black", fontWeight: 'bold' }}>
        {badgeCounts[menu.title]}
      </div>
    ) : null;

  let highlight = menu.highlight && (
    <i className="fa fa-paper-plane text-theme"></i>
  );

  let title = menu.title && (
    <div className="menu-text">
      {currentLang?.[menu.title] || menu.title} {label} {highlight}
    </div>
  );


  function handleMenuClick(e, menuTitle, path) {
    const savedtransactionPending = getStoredValue("transactionPending");
    if (savedtransactionPending != null) {
      setIsSaveTriggered(true);
    }
    if (menuTitle == "Sent Photos") {
      dispatch(sendPhotosActions.clearPhotosDetailsResponse());
    }
    if (menuTitle == "WriteMessage") {
      dispatch(writeMessageActions.setSelectedCategories([]));
    }
    const fullUrl = window.location.origin + "/" + path;
    setStoredValue("currentRoute", fullUrl);
    dispatch(masterActions.updateCurrentName(menuTitle));
    const publicUserId = getStoredValue("userID");
    dispatch(archivedActions.PULoginUnreadNotificationCount({ publicUserId }))
      .then(() => {
      })
      .catch((error) => {
        console.error("Error updating notification count:", error);
      });
    const infoMessage = `${menuTitle || "LogOut"} - Menu Click`;
    const redirectURL = path;
    const Response = '---';
    const Status = '---';
    EventLog(dispatch, infoMessage, redirectURL, Response, Status)
    navigate(path);
    context.toggleAppSidebarMobile(e);
  }

  return (
    <div
      className={
        "menu-item" +
        (match || match2 ? " active" : "") +
        (menu.children ? " has-sub" : "")
      }
    >
      <NavLink
        className="menu-link"
        to={menu.title === "LogOut" ? "" : menu.path}
        title={menu.title}
        {...props}
        onClick={(e) =>
          handleMenuClick(
            e,
            menu.title,
            menu.title === "LogOut" ? "" : menu.path
          )
        }
      >
        {img} {icon} {title}
        {caret} {badge}
      </NavLink>

      {menu.children && (
        <div className="menu-submenu">
          {menuData.map.map((submenu, i) => (
            <NavItem key={i} menu={submenu} />
          ))}
        </div>
      )}
    </div>
  );
}


function SidebarNav() {
  const currentLang = translations();
  const context = useContext(AppSettings);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { setIsSaveDraftModified } = useDraft();
  const { setIsTransactionModified } = useTransactionPending();
  const location = useLocation();
  const [activeIndex, setActiveIndex] = useState(null);

  const logout = () => {
    if (
      getStoredValue("UserName") === null &&
      getStoredValue("UserPassword") === null
    ) {
      removeStoredValue("logicResult");
      removeStoredValue("lang"); // Remove Spanish setting if exists
      setStoredValue("lang", "en"); // Resetting to English
      dispatch(myAccountActions.clearPublicUserLoginStatusResponse());
      dispatch(authActions.logout());
      navigate("/public/Login"); // Navigates to login after logout
      // Auto Draft save
      const savedDraft = getStoredValue("draft");
      if (savedDraft != null) {
        setIsSaveDraftModified(true);
      }
      const savedtransactionPending = getStoredValue("transactionPending");
      if (savedtransactionPending != null) {
        setIsTransactionModified(true);
      }
    }
  };

  function handleSidebarSearch(e) {
    let targetValue = e.target.value;
    targetValue = targetValue.toLowerCase();

    if (targetValue) {
      const elms = Array.from(
        document.querySelectorAll(
          ".app-sidebar:not(.app-sidebar-end) .menu > .menu-item:not(.menu-profile):not(.menu-header):not(.menu-search), .app-sidebar:not(.app-sidebar-end) .menu-submenu > .menu-item"
        )
      );
      if (elms) {
        elms.forEach((elm) => elm.classList.add("d-none"));
      }
      const elms2 = Array.from(
        document.querySelectorAll(
          ".app-sidebar:not(.app-sidebar-end) .has-text"
        )
      );
      if (elms2) {
        elms2.forEach((elm) => elm.classList.remove("has-text"));
      }
      const elms3 = Array.from(
        document.querySelectorAll(".app-sidebar:not(.app-sidebar-end) .expand")
      );
      if (elms3) {
        elms3.forEach((elm) => elm.classList.remove("expand"));
      }
      const elms4 = Array.from(
        document.querySelectorAll(
          ".app-sidebar:not(.app-sidebar-end) .menu > .menu-item:not(.menu-profile):not(.menu-header):not(.menu-search) > .menu-link, .app-sidebar .menu-submenu > .menu-item > .menu-link"
        )
      );
      if (elms4) {
        elms4.forEach((elm) => {
          const targetText = elm.textContent.toLowerCase();
          if (targetText.includes(targetValue)) {
            const targetElm = elm.closest(".menu-item");
            if (targetElm) {
              targetElm.classList.remove("d-none");
              targetElm.classList.add("has-text");
            }

            const targetElm2 = elm.closest(".menu-item.has-sub");
            if (targetElm2) {
              const targetElm3 = targetElm.querySelector(
                ".menu-submenu .menu-item.d-none"
              );
              if (targetElm3) {
                targetElm3.classList.remove("d-none");
              }
            }

            const targetElm4 = elm.closest(".menu-submenu");
            if (targetElm4) {
              targetElm4.style.display = "block";

              const targetElm5 = targetElm.querySelector(
                ".menu-item:not(.has-text)"
              );
              if (targetElm5) {
                targetElm5.classList.add("d-none");
              }

              const targetElm6 = elm.closest(".has-sub:not(.has-text)");
              if (targetElm6) {
                targetElm6.classList.remove("d-none");
                targetElm6.classList.add("expand");

                const targetElm7 = targetElm.closest(".has-sub:not(.has-text)");
                if (targetElm7) {
                  targetElm7.classList.remove("d-none");
                  targetElm7.classList.add("expand");
                }
              }
            }
          }
        });
      }
    } else {
      const elms5 = Array.from(
        document.querySelectorAll(
          ".app-sidebar:not(.app-sidebar-end) .menu > .menu-item:not(.menu-profile):not(.menu-header):not(.menu-search).has-sub .menu-submenu"
        )
      );
      if (elms5) {
        elms5.forEach((elm) => elm.removeAttribute("style"));
      }

      const elms6 = Array.from(
        document.querySelectorAll(
          ".app-sidebar:not(.app-sidebar-end) .menu > .menu-item:not(.menu-profile):not(.menu-header):not(.menu-search)"
        )
      );
      if (elms6) {
        elms6.forEach((elm) => elm.classList.remove("d-none"));
      }

      const elms7 = Array.from(
        document.querySelectorAll(
          ".app-sidebar:not(.app-sidebar-end) .menu-submenu > .menu-item"
        )
      );
      if (elms7) {
        elms7.forEach((elm) => elm.classList.remove("d-none"));
      }

      const elms8 = Array.from(
        document.querySelectorAll(".app-sidebar:not(.app-sidebar-end) .expand")
      );
      if (elms8) {
        elms8.forEach((elm) => elm.classList.remove("expand"));
      }
    }
  }


  return (
    <div className="menu">
      {context.appSidebarSearch && (
        <div className="menu-search mb-n3">
          <input
            type="text"
            className="form-control"
            placeholder="Sidebar menu filter..."
            onKeyUp={handleSidebarSearch}
          />
        </div>
      )}

      {menus.map((menu, i) =>
        menu.title !== "Logout" ? (
          <div
            key={i}
            className={`menu menu-item ${activeIndex === i ? "active" : ""}`}
            onBlur={() => setActiveIndex(null)} // Remove active when losing focus
          >
            <NavItem
              menu={menu}
              tabIndex={0} // Ensure NavItem is focusable
              onFocus={() => setActiveIndex(i)} // Set active on focus
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault(); // Prevent navigation on Enter key
                }
              }}
            />
          </div>
        ) : (
          <div
            key={i}
            className={`menu menu-item ${activeIndex === i ? "active" : ""}`} // Apply active class when focused
            onClick={logout}
            role="button"
            style={{ cursor: "pointer" }}
            tabIndex={0} // Make logout focusable via keyboard
            onFocus={() => setActiveIndex(i)}
            onBlur={() => setActiveIndex(null)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault(); // Prevent navigation on Enter key
              }
            }}
          >
            <div
              className="menu-link"
              title={currentLang?.Logout}
            >
              <div className="menu-icon">
                <i className="fa fa-sign-out"></i>
              </div>
              <div className="menu-text">
                {currentLang?.Logout}
              </div>
            </div>
          </div>
        )
      )}
    </div>
  );
}

export default SidebarNav;
